import React from "react";
import { Route, Routes } from "react-router-dom";
import AdminPage from "./pages/AdminPage";
import KeyPage from "./pages/KeyPage";
import LabListPage from "./pages/LabListPage";
import LoginPage from "./pages/LoginPage";
import MainPage from "./pages/MainPage";
import MasterListPage from "./pages/MasterListPage";
import ReagentListPage from "./pages/ReagentListPage";
import ReagentDetailPage from "./pages/ReagentsDetailPage";
import Layout from "./Layout";
import { PrivateRoute } from "./privateroute";
import { UserProvider } from "./provider/Provider";

function AppRoutes(): React.ReactElement {
  return (
    <UserProvider>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route element={<Layout/>}>
          <Route
            path="/labs"
            element={
              <PrivateRoute>
                <LabListPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/alerts"
            element={
              <PrivateRoute>
                <MainPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reagents"
            element={
              <PrivateRoute>
                <MasterListPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reagents/group/:groupId"
            element={
              <PrivateRoute>
                <ReagentListPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/reagents/:id"
            element={
              <PrivateRoute>
                <ReagentDetailPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/keys"
            element={
              <PrivateRoute>
                <KeyPage />
              </PrivateRoute>
            }
          />
          <Route
          path="/admin"
            element={
              <PrivateRoute>
                <AdminPage />
              </PrivateRoute>
            }
          />
        </Route>
      </Routes>
    </UserProvider>
  );
}

export { AppRoutes };
